import React from "react";
import { Lazy } from "@/components/Lazy";
import { Link } from "../Link";
import { Typography } from "@/components/Typography";
import { BiLinkExternal } from "react-icons/bi";
import { PreviewHeadingBlockProps } from "./types";
import { checkValidURL } from "@/utils/formHelper";
import { optimizeCloudinaryImage } from "@/services/CloudinaryService";

import "./styles.scss";

export const PreviewHeadingBlock = ({
  isInitPreview,
  image,
  title,
  text,
  actionText,
  actionUrl,
  actionColor,
}: PreviewHeadingBlockProps) => {
  if (!image && !title && !text) return null;

  const renderImage = () => {
    if (!image) {
      return null;
    }

    const imageSrc = isInitPreview
      ? image
      : optimizeCloudinaryImage({
          url: image,
          transformations: ["f_auto,q_auto,w_1280,h_640,dpr_auto,c_fill"],
        });

    return (
      <div className="preview-heading__image-container">
        <Lazy placeholderClass="preview-heading__image-element">
          <img
            src={optimizeCloudinaryImage({
              url: imageSrc,
              transformations: ["f_auto,q_auto,w_1280,h_640,dpr_auto,c_fill"],
            })}
            className="preview-heading__image-element"
          />
        </Lazy>
      </div>
    );
  };

  const renderTitle = () => {
    if (!title) {
      return null;
    }
    return (
      <div
        className={`preview-heading__title ${image ? "preview-heading__title--with-image" : ""} `}>
        <Typography
          Tag="p"
          size="l"
          classname="u-semibold u-spacing-4">
          {title}
        </Typography>
      </div>
    );
  };

  const renderText = () => {
    if (!text) {
      return null;
    }
    return (
      <div className="preview-heading__text">
        <Typography
          Tag="p"
          classname="u-spacing-3">
          {text}
        </Typography>
      </div>
    );
  };

  const renderActionButton = () => {
    if (!actionText) {
      return null;
    }
    return (
      <div className="preview-heading__action">
        <Link
          className="button u-spacing-2"
          href={checkValidURL(actionUrl) || ""}
          style={{ backgroundColor: actionColor }}
          externalLink
          type="button"
          prefetch={false}>
          <BiLinkExternal className="button__icon" />
          <span
            data-testid="button-label"
            className="button__text">
            {actionText}
          </span>
        </Link>
      </div>
    );
  };

  return (
    <div className="preview-heading">
      {renderImage()}
      <div className="preview-heading__text-container">
        {renderTitle()}
        {renderText()}
        {renderActionButton()}
      </div>
    </div>
  );
};
